var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCrossBlackHeavy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#333333;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.7,17.5l-2.2-2.2L9.8,12L6.5,8.7l2.2-2.2L12,9.8l3.3-3.3l2.2,2.2L14.2,12l3.3,3.3l-2.2,2.2L12,14.2L8.7,17.5z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCrossBlackHeavy);
export default __webpack_public_path__ + "static/media/close-cross-black-heavy.a960badd94c09e0cec2268f7d85f448a.svg";
export { ForwardRef as ReactComponent };